<button type="button" class="btn btn-menu" [matMenuTriggerFor]="menu" [matTooltip]="buttonExtendedText">
  <span class="ellipsis">
    {{ buttonExtendedText }}
  </span>
  <craft-icon class="svg-icon text-size-11 icon-arrow shrink-0" name="arrows--arrow-head-down-sm"></craft-icon>
  <craft-icon
    class="svg-icon icon-remove text-size-8"
    matTooltip="Remove filter"
    matTooltipPosition="above"
    (click)="removeFilter($event)"
    name="general--close-sm"
  ></craft-icon>
</button>

<craft-icon
  class="svg-icon icon-clear text-size-9"
  matTooltip="Clear filter"
  matTooltipPosition="above"
  (click)="clearSelected()"
  name="general--close-sm"
></craft-icon>

<mat-menu #menu="matMenu" class="filter-number-dropdown">
  <ng-template matMenuContent="">
    <div class="menu-content" (click)="$event.stopPropagation()">
      <div class="row">
        <mat-checkbox [checked]="isBetweenChecked" (change)="resetNumbers($event)"> Is Between </mat-checkbox>
        <div class="inputs">
          <craft-number-input
            class="number-input"
            [allowNull]="true"
            [max]="selectedValue.max"
            [value]="selectedValue.min"
            (update)="setNumberValue('min', $event)"
          ></craft-number-input>
          <span>-</span>
          <craft-number-input
            class="number-input"
            [allowNull]="true"
            [min]="selectedValue.min"
            [value]="selectedValue.max"
            (update)="setNumberValue('max', $event)"
          ></craft-number-input>
        </div>
      </div>
      <div class="row">
        <mat-checkbox [checked]="selectedValue.noValue" (change)="setNoValue($event)"> No Value </mat-checkbox>
      </div>
    </div>
    <div class="dropdown-footer d-flex justify-between">
      <button (click)="clearSelected($event)" type="button" class="btn">Clear</button>
      <button (click)="applyFilters($event)" type="button" class="btn btn-blue" mat-button="">Apply</button>
    </div>
  </ng-template>
</mat-menu>
